// src/documents/spolTemplate.js
//
// Mapa de campos de la Sworn Statement in Proof of Loss sobre la plantilla
// src/assets/documents/spol-template.pdf (reconstruida por el cliente,
// 2026-09-23). Coordenadas tomadas del SVG exportado de esa misma
// plantilla (y = 0 arriba). Si cambia la plantilla, se ajusta solo acá.

const AMOUNT = { page: 0, x: 475.5, width: 92.16, align: 'right' };

export const SPOL_TEMPLATE = {
  fields: [
    // Encabezado
    { key: 'policyNumber', page: 0, x: 36, y: 56.6, width: 148.58, align: 'center' },
    { key: 'policyAmount', page: 0, x: 205.85, y: 56.6, width: 191.42, align: 'center' },
    { key: 'claimNumber', page: 0, x: 418.6, y: 56.6, width: 156.98, align: 'center' },
    { key: 'policyIssued', page: 0, x: 36, y: 86.85, width: 63.98, align: 'center' },
    { key: 'policyExpires', page: 0, x: 121.2, y: 86.85, width: 71.18, align: 'center' },
    { key: 'agentName', page: 0, x: 220.45, y: 86.85, width: 191.3, align: 'center' },
    { key: 'agencyAt', page: 0, x: 433, y: 86.9, width: 142.89, align: 'center' },

    // "To the claims department of ___ ... you insured ___ against loss by ___"
    { key: 'insuranceCompany', page: 0, x: 130.13, y: 113.54, width: 68.18 },
    { key: 'insuredNames', page: 0, x: 428.57, y: 113.06, width: 100.58 },
    { key: 'peril', page: 0, x: 45.38, y: 124.13, width: 88.34 },

    // TIME AND ORIGIN
    { key: 'peril', page: 0, x: 110.93, y: 145.01, width: 61.94 },
    { key: 'hourPhrase', page: 0, x: 172.4, y: 146.1, width: 179, size: 7.9, plain: true },
    { key: 'lossDay', page: 0, x: 352.68, y: 145.49, width: 14.18, align: 'center' },
    { key: 'dayOfLabel', page: 0, x: 368, y: 146.1, width: 20, size: 7.9, plain: true },
    { key: 'lossMonth', page: 0, x: 388.94, y: 145.49, width: 43.7, align: 'center' },
    { key: 'lossYear', page: 0, x: 432.2, y: 146.1, width: 24, size: 7.9, plain: true },
    { key: 'causeAndOrigin', page: 0, x: 256.42, y: 158.69, width: 52.58, maxWidth: 314 },

    // OCCUPANCY / TITLE AND INTEREST / CHANGES
    { key: 'occupancy', page: 0, x: 139.01, y: 179.81, width: 50.42, maxWidth: 431 },
    { key: 'insuredInterest', page: 0, x: 393.74, y: 193.49, width: 35.3, maxWidth: 176 },
    // Lo que no entra en la raya de "except:" sigue en la línea en blanco de abajo.
    { key: 'encumbrance', page: 0, x: 410.3, y: 203.33, width: 147.19, maxWidth: 160, wrapTo: { x: 97, y: 214.2, width: 470 } },
    { key: 'changesExcept', page: 0, x: 246.82, y: 239.11, width: 17.04, maxWidth: 320 },

    // TOTAL / VALUE
    { key: 'totalInsurance', page: 0, x: 462.41, y: 256.63, width: 58.58, align: 'right' },
    { key: 'actualCashValue', ...AMOUNT, x: 474.8, width: 92.88, y: 289.15 },

    // The Whole Loss and Damage
    { key: 'claimedTotal', ...AMOUNT, y: 302.27 },
    { key: 'claimedA', ...AMOUNT, y: 312.27 },
    { key: 'claimedB', ...AMOUNT, y: 322.8 },
    { key: 'claimedC', ...AMOUNT, y: 332.8 },
    { key: 'claimedD', ...AMOUNT, y: 343.33 },
    { key: 'deductible', ...AMOUNT, y: 353.18 },
    { key: 'subTotal', ...AMOUNT, y: 363.86 },
    { key: 'emsVendors', ...AMOUNT, y: 373.71 },
    { key: 'netClaimed', ...AMOUNT, x: 474.8, width: 92.88, y: 384.39 }

    // El bloque de firma (By: Insured / Insured:) queda en blanco: el cliente
    // lo llena a mano en físico junto con la notaría (pedido del 2026-10-19).
  ],

  // Texto fijo que dejó la reconstrucción y que hay que reemplazar:
  // "12 o'clock PM." (hora fija), el "AM/" que quedó en la línea de abajo,
  // el "20__" del año y los puntos finales que caerían encima del dato.
  patches: [
    { page: 0, x: 172.4, y: 137.6, width: 179.6, height: 9.2 }, // "loss occurred about the hour of 12 o'clock PM., on the"
    { page: 0, x: 104.2, y: 151.2, width: 14.7, height: 9.2 },  // "AM/"
    { page: 0, x: 352.5, y: 137.6, width: 36, height: 7.6 },    // "_day of" (montado sobre la raya del día; se reescribe a la derecha)
    { page: 0, x: 432.2, y: 137.6, width: 24, height: 9.2 },    // "20__"
    { page: 0, x: 308.5, y: 151.2, width: 4, height: 9.2 },     // "." tras cause and origin
    { page: 0, x: 428.6, y: 185.6, width: 4, height: 9.2 }      // "." tras interest
  ]
};
